<!-- @veltra/icons generated sha256:c3da175ea27c3627 gen:8 source:src/svg/normal/cloudy.svg -->
<script setup lang="ts">
defineOptions({ name: 'Cloudy' })
</script>
<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
    <path
      fill="currentColor"
      d="m4.806 6.908.075-.348C5.197 5.079 6.484 3.999 8 3.999s2.803 1.08 3.12 2.561l.074.348a.49.49 0 0 0 .42.394c.182.02.367.043.367.043C13.105 7.475 14 8.452 14 9.665 14 10.972 12.963 12 11.733 12H4.267C3.037 11.999 2 10.97 2 9.666c0-1.214.896-2.19 2.018-2.321l.367-.043a.49.49 0 0 0 .421-.394m7.291-.557C11.687 4.427 10.007 3 8 3S4.313 4.427 3.903 6.35C2.269 6.541 1 7.951 1 9.666c0 1.838 1.465 3.333 3.267 3.333h7.466c1.802 0 3.267-1.495 3.267-3.333 0-1.715-1.27-3.124-2.903-3.315"
    />
  </svg>
</template>
